import React, { useState, useEffect, useContext } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import AppContext from '../AppContext';


export default function NameFilter({setnameFilter}) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const myContext = useContext(AppContext);

  React.useEffect(() => {
    let active = true;

    if (!loading) {
        console.log("Not loading...");
        return undefined;
    }

    (async () => {

      if (active) {
          // setOptions([...topFilms]);          
        setOptions([...myContext.requests]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      id="asynchronous-demo"
      sx={{ width: 300 }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={(e) => {
        // console.log(e);
        console.log(`setting namefilter to ${e.target.innerText}`);
        setnameFilter(e.target.innerText);
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option.recipientName === value.recipientName}
      getOptionLabel={(option) => option.recipientName}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search Name"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
